import React, { useEffect, useState } from "react";
import "../styles/App.css";
import Header from "./Header";
import { createChat } from '@n8n/chat';
import '@n8n/chat/style.css';
import '../styles/ChatbotThemeDataPulse.css';

const webhookUrl = 'https://n8n.mydatapulse.co.uk/webhook/f430db27-651e-4a55-acbb-45aa55f0ad84/chat';
const API = process.env.REACT_APP_API_BASE_URL;
const testWebhookProxy = `${API}/check-webhook`;

export const DataPulseChatbot = () => {
  const [isWebhookLive, setIsWebhookLive] = useState(false);

  useEffect(() => {
    const checkWebhook = async () => {
      try {
        const res = await fetch(testWebhookProxy);
        const json = await res.json();
        if (json?.live) {
          setIsWebhookLive(true);
        } else {
          setIsWebhookLive(false);
        }
      } catch (err) {
        console.warn('Webhook check failed:', err);
        setIsWebhookLive(false);
      }
    };

    checkWebhook();
  }, []);

  useEffect(() => {
    if (!isWebhookLive) return;

    createChat({
      webhookUrl,
      webhookConfig: { method: 'POST', headers: {} },
      branding: {
        logo: "https://www.mydatapulse.co.uk/logo192_transparent.png",
        name: "DataPulse",
        description: "Your AI Assistant",
      },
      target: '#n8n-chat',
      mode: 'window',
      chatInputKey: 'chatInput',
      chatSessionKey: 'sessionId',
      metadata: {},
      showWelcomeScreen: false,
      defaultLanguage: 'en',
      initialMessages: [
        "Hi! 👋 My name is Pulse - I'm DataPulse's AI assistant.",
        "How can I help?",
      ],
      i18n: {
        en: {
          title: "Hi there, I'm Pulse! 🧠",
          subtitle: "",
          footer: '',
          getStarted: 'New Conversation',
          inputPlaceholder: 'Type your question here..',
        },
      },
    });
  }, [isWebhookLive]);

  return isWebhookLive ? <div id="n8n-chat" /> : null;
};

export default DataPulseChatbot;
